"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getSwaggerJSONV3;
    }
});
const _swaggerUtils = require("../shared/swaggerUtils");
const _swaggerbasev3json = /*#__PURE__*/ _interop_require_default(require("./swagger-base-v3.json"));
const _getPathsV3 = /*#__PURE__*/ _interop_require_default(require("./getPathsV3"));
const _getSchemasV3 = /*#__PURE__*/ _interop_require_default(require("./getSchemasV3"));
const _getSwaggerColumnMetasV3 = /*#__PURE__*/ _interop_require_default(require("./getSwaggerColumnMetasV3"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getSwaggerJSONV3(context, { base, sourcesMap, models }, ncMeta = _Noco.default.ncMeta) {
    return (0, _swaggerUtils.generateSwagger)({
        context,
        base,
        models,
        sourcesMap,
        ncMeta
    }, _swaggerbasev3json.default, _getSwaggerColumnMetasV3.default, _getPathsV3.default, _getSchemasV3.default);
}
